export enum EValidatePropertiesComponentType {
  Text = 0,
  Number = 1,
  Date = 2,
  Dropdown = 3,
  Checkbox = 4,
}